<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titlePage" start="false" end="false"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">

  <div class="w-title">
    <app-ion-common-label class="document-type-label1 w-title" labelStyle="display-rg" 
      labelDescription="Para continuar você precisa informar {{titleInf}}."
      label="Você pode informar qualquer {{subTitleInf}}.">
    </app-ion-common-label>
  </div>
  <p class="info-page">Esta é uma exigência dos órgãos reguladores para garantir que suas operações são compatíveis
    com seus rendimentos. Você não precisa se preocupar ao fornecer suas informações, elas estão protegidas por sigilo bancário. 
  </p>
  
  <app-ion-common-button label="Informar renda ou patrimônio" (clickButton)="clickNext();"></app-ion-common-button>

</ion-content>

